import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { articlesApiUrl as ArticlesQK } from './api';
import { ResponseType } from 'src/constants/data';

export const useGetArticle = (slug?: string) => {
  return useQuery({
    queryKey: [ArticlesQK, ResponseType.Single, slug],
    queryFn: () => API.getArticleBySlug(slug),
    placeholderData: keepPreviousData,
    enabled: !!slug
  });
};
